import { request, callApi, capitalize, DEFAULT_LOCALE } from 'utils';
import { FETCH_BANKS_EXCHRATES_LIST } from 'actionTypes';

export const fetchBanksExchrates = ({
  currency,
  locale = DEFAULT_LOCALE,
  intl,
  date = null,
  city = null,
  cpp = 80,
}) => {
  // https://minfin.com.ua/api/currency/rates/banks/usd
  const currentLocale = intl?.locale || locale;

  const action = () =>
    request({
      url: `${process.env.APP_CURRENCIES_API_URL}/rates/banks/${currency}/?page=1&cpp=${cpp}`,
      method: 'get',
      params: {
        ...({ city } || {}),
        ...({ date } || {}),
        commercial_sort: true,
      },
    }).then(({ data }) => {
      return data.map(item => {
        const labelKey = `name${capitalize(currentLocale)}`;

        return {
          name: item[labelKey],
          slug: item.slug,
          logo: item.logo,
          commercialPlacement: item?.commercialPlacement,
          cash: {
            ...item.cash,
            bid: item.cash?.bid ? Number(item.cash.bid) : 0,
            ask: item.cash?.ask ? Number(item.cash.ask) : 0,
          },
          card: {
            ...item.card,
            bid: item.card?.bid ? Number(item.card.bid) : 0,
            ask: item.card?.ask ? Number(item.card.ask) : 0,
          },
        };
      });
    });

  return callApi(action, FETCH_BANKS_EXCHRATES_LIST);
};
